import React, { FC, useState } from 'react'
import { useField } from 'formik'
import { useTranslations } from 'next-intl'
import { EMAIL_FIELD_NAME, EMAIL_FIELD_DESCRIPTION } from '../constants'
import { EmailField } from '../../RegistrationForm/components/EmailField/EmailField'
import { TextWrapper } from '../../RegistrationForm/components/TextWrapper/TextWrapper'
import { Validate } from '../../../validator/IFormValues'
import { sendGATagEvent } from '../../../utils/sendGATagEvent'

type FormEmailFieldProps = {
  validate?: Validate
}

export const FormEmailField: FC<FormEmailFieldProps> = ({ validate }) => {
  const [isEmailBusy, isEmailBusyChange] = useState<boolean>(false)
  const t = useTranslations()
  const emailFieldName = t(EMAIL_FIELD_NAME)
  const emailFieldDescription = t(EMAIL_FIELD_DESCRIPTION)
  const [field, , helper] = useField('email')

  return (
    <EmailField
      name={field.name}
      wrapErrorText
      label={<TextWrapper label={emailFieldName} description={emailFieldDescription} />}
      isBusy={isEmailBusy}
      validate={
        validate &&
        validate(field.name, () => {
          isEmailBusyChange(true)
          sendGATagEvent('event', 'Emailexists', {
            event_category: 'Registration',
            event_label: window.location.href,
          })
        })
      }
      onBlurHandler={() => helper.setError('')}
      onChangeHandler={() => isEmailBusyChange(false)}
    />
  )
}

FormEmailField.displayName = 'FormEmailField'
